var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "name_group" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                disabled: "",
                size: "small",
                clearable: "",
                placeholder: "版本号",
              },
              model: {
                value: _vm.projectName,
                callback: function ($$v) {
                  _vm.projectName = $$v
                },
                expression: "projectName",
              },
            },
            [_c("el-option", { attrs: { label: "版本1", value: 1 } })],
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "150px" },
              attrs: { size: "small", clearable: "", placeholder: "代理商" },
              model: {
                value: _vm.agentId,
                callback: function ($$v) {
                  _vm.agentId = $$v
                },
                expression: "agentId",
              },
            },
            _vm._l(_vm.agentList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "150px" },
              attrs: { size: "small", clearable: "", placeholder: "结算类型" },
              model: {
                value: _vm.settleType,
                callback: function ($$v) {
                  _vm.settleType = $$v
                },
                expression: "settleType",
              },
            },
            [
              _c("el-option", { attrs: { label: "整单结算", value: 0 } }),
              _c("el-option", { attrs: { label: "月度暂结", value: 1 } }),
              _c("el-option", { attrs: { label: "整单暂结", value: 2 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "150px" },
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "请选择结算数据源",
              },
              model: {
                value: _vm.dataType,
                callback: function ($$v) {
                  _vm.dataType = $$v
                },
                expression: "dataType",
              },
            },
            [
              _c("el-option", { attrs: { label: "秒针IES", value: 1 } }),
              _c("el-option", { attrs: { label: "乐播云", value: 2 } }),
              _c("el-option", { attrs: { label: "客户数据-实结", value: 3 } }),
              _c("el-option", { attrs: { label: "客户数据-全结", value: 4 } }),
              _c("el-option", { attrs: { label: "历史结算导入", value: 5 } }),
            ],
            1
          ),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { size: "small", clearable: "", placeholder: "项目/编号" },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "success" },
              on: { click: _vm.searchData },
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-edit", size: "small", type: "warning" },
              on: { click: _vm.editDataType },
            },
            [_vm._v("修改")]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-upload", size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.updateDataDialogShow = true
                },
              },
            },
            [_vm._v("上传数据")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.originalOrderDialogShow = true
                },
              },
            },
            [_vm._v("原始订单")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                icon: "el-icon-refresh",
                size: "small",
                type: "success",
              },
              on: { click: _vm.getDataUpdateStatus },
            },
            [_vm._v("刷新")]
          ),
          _c(
            "span",
            { staticClass: "refresh-warp" },
            [
              _vm.updateStatus === 1
                ? [
                    _vm._v(
                      "\n        乐播云及IES数据 数据更新中，请稍侯......\n      "
                    ),
                  ]
                : [
                    _vm._v(
                      "\n        乐播云及IES数据更新时间：" +
                        _vm._s(_vm.updateTime || "无") +
                        " "
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.updateProjectData },
                      },
                      [_vm._v("更新数据")]
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", type: "selection", width: "50" },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "",
              prop: "agentName",
              label: "代理商",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "",
              prop: "orderNo",
              label: "项目编号",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: { align: "left", label: "项目名称", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.parentId > 0 ? "【子项目】" : "") +
                          _vm._s(scope.row.orderName)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "结算类型", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class:
                          scope.row.settleType == 2
                            ? "red"
                            : scope.row.settleType == 0
                            ? "green"
                            : scope.row.settleType == 1
                            ? "blue"
                            : "",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm._f("adSettleStatus")(scope.row.settleType))
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "结算数据源", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("adSettleSource")(scope.row.dataType))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              prop: "customerCurrCpm",
              label: "上传数据(整单)",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.dataType === 1 || scope.row.dataType === 2
                      ? [_c("span")]
                      : [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                scope.row.customerCurrCpm > 0
                                  ? scope.row.customerCurrCpm
                                  : "待上传"
                              ) +
                              "\n        "
                          ),
                        ],
                    _c("span"),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "right", prop: "totalCpm", label: "IES数据" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.iesCurrCpm > -1 ? scope.row.iesCurrCpm : ""
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              prop: "lbTotalCpm",
              label: "乐播云",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.lbCurrCpm > -1 ? scope.row.lbCurrCpm : ""
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "right",
              width: "100",
              label: "原始订单",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.sfileName == ""
                      ? _c("span", [_vm._v("待上传")])
                      : _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadOrgin(scope.row)
                              },
                            },
                          },
                          [_vm._v("下载")]
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalEl,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("editProjectDialog", {
        attrs: {
          projectDialogFlag: _vm.projectDialogShow,
          projectInfo: _vm.projectInfo,
          changeProject: _vm.selectProject,
        },
        on: {
          "update:projectDialogFlag": function ($event) {
            _vm.projectDialogShow = $event
          },
          "update:project-dialog-flag": function ($event) {
            _vm.projectDialogShow = $event
          },
        },
      }),
      _c("updateDataDailog", {
        attrs: {
          updateDataDialogFlag: _vm.updateDataDialogShow,
          projectInfo: _vm.projectInfo,
        },
        on: {
          "update:updateDataDialogFlag": function ($event) {
            _vm.updateDataDialogShow = $event
          },
          "update:update-data-dialog-flag": function ($event) {
            _vm.updateDataDialogShow = $event
          },
        },
      }),
      _c("originalOrderDialog", {
        attrs: {
          orginalOrderDialogFlag: _vm.originalOrderDialogShow,
          projectInfo: _vm.projectInfo,
        },
        on: {
          "update:orginalOrderDialogFlag": function ($event) {
            _vm.originalOrderDialogShow = $event
          },
          "update:orginal-order-dialog-flag": function ($event) {
            _vm.originalOrderDialogShow = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }